export var HLS_HANDLER_ID="@dicetechnology/doris-handler-hls";